import config from '../config';

const makePhotoUrl = (photo: string) =>
  photo && `${config.imageAPIBaseURL}/${photo}`;

export default makePhotoUrl;
